import { authFeature } from './auth.reducer';

export const { selectDataIndexToken, selectAiGatewayToken } = authFeature;
